// hooks/useFieldConfig.ts
import { useMemo } from "react";

interface LocationOption {
  id: number;
  name?: string;
  full_name?: string;
}

interface FieldConfigOptions {
  regions?: LocationOption[];
  countries?: LocationOption[];
  companyStates?: LocationOption[];
  companyCities?: LocationOption[];
  contactStates?: LocationOption[];
  contactCities?: LocationOption[];
  tzOptions?: { label: string; value: string }[];
  suggestedTimezone?: string | null;
  localTimezone?: string | null;
  timezoneValue?: string;
}

export function useFieldConfig(baseConfig: any[], options: FieldConfigOptions) {
  return useMemo(() => {
    return baseConfig.map((field) => {
      switch (field.name) {
        case "region_id":
          if (options.regions) {
            return {
              ...field,
              options: [
                { label: "-- Select Region --", value: "" },
                ...options.regions.map((r) => ({
                  label: r.full_name || r.name || "",
                  value: String(r.id),
                })),
              ],
            };
          }
          return field;

        case "timezone":
          if (options.tzOptions) {
            return {
              ...field,
              options: [
                { label: "-- Select Timezone --", value: "" },
                ...options.tzOptions,
              ],
              belowNote: options.suggestedTimezone
                ? `Suggested: ${options.suggestedTimezone}`
                : options.localTimezone && !options.timezoneValue
                ? `Default: ${options.localTimezone}`
                : undefined,
            };
          }
          return field;

        case "company_country_id":
          if (options.countries) {
            return {
              ...field,
              options: [
                { label: "-- Select Country --", value: "" },
                ...options.countries.map((c) => ({
                  label: c.name || "",
                  value: String(c.id),
                })),
              ],
            };
          }
          return field;

        case "company_state_id":
          if (options.companyStates) {
            return {
              ...field,
              options: [
                { label: "-- Select State --", value: "" },
                ...options.companyStates.map((s) => ({
                  label: s.name || "",
                  value: String(s.id),
                })),
              ],
            };
          }
          return field;

        case "company_city_id":
          if (options.companyCities) {
            return {
              ...field,
              options: [
                { label: "-- Select City --", value: "" },
                ...options.companyCities.map((c) => ({
                  label: c.name || "",
                  value: String(c.id),
                })),
              ],
            };
          }
          return field;

        case "country_id":
          if (options.countries) {
            return {
              ...field,
              options: [
                { label: "-- Select Country --", value: "" },
                ...options.countries.map((c) => ({
                  label: c.name || "",
                  value: String(c.id),
                })),
              ],
            };
          }
          return field;

        case "state_id":
          if (options.contactStates) {
            return {
              ...field,
              options: [
                { label: "-- Select State --", value: "" },
                ...options.contactStates.map((s) => ({
                  label: s.name || "",
                  value: String(s.id),
                })),
              ],
            };
          }
          return field;

        case "city_id":
          if (options.contactCities) {
            return {
              ...field,
              options: [
                { label: "-- Select City --", value: "" },
                ...options.contactCities.map((c) => ({
                  label: c.name || "",
                  value: String(c.id),
                })),
              ],
            };
          }
          return field;

        default:
          return field;
      }
    });
  }, [baseConfig, options]);
}
